module.exports = __webpack_public_path__ + "img/icon-01.f19c684c.png";